import styled from "styled-components";

export const LastDaysOverviewContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1em;
`;

